import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

type Tone = "neutral" | "brand" | "success" | "warning" | "danger" | "info" | "ai" | "task";

const TONE: Record<Tone, string> = {
  neutral: "bg-surface-raised text-fg-secondary",
  brand: "bg-brand-100 text-brand-700",
  success: "bg-success-bg text-success",
  warning: "bg-warning-bg text-warning",
  danger: "bg-danger-bg text-danger",
  info: "bg-brand-50 text-info",
  ai: "bg-brand-50 text-accent-ai",
  task: "bg-brand-50 text-accent-task",
};

export interface BadgeProps {
  tone?: Tone;
  className?: string;
  children: ReactNode;
}

export function Badge({ tone = "neutral", className, children }: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium",
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
